<script>
import {
    mapGetters
} from 'vuex';
import { eventBus } from '@/components/competences/event-bus';

export default {
    name: 'CompetenceCardDataProvider',
    computed: mapGetters('competences', {
		competenceCard: 'competenceCard',
		loading: 'loading',
		competenceRows: 'competenceRows',
		courseRows: 'courseRows',
		workplaceOptions: 'workplaceOptions',
    }),
	props: {
		competenceCardId: {
			type: String,
			default: '0'
		}
	},
	data() {
		return {
			dataId: '0',
			success: false,
			mode: 'view'
		}
	},
	methods: {
		create({ firstName, surName, personalIdentityNumber, employeeNumber, employmentDate, email, role, drivingLicense, workplaceId, experience, education }) {
			this.$store.dispatch('competences/addCompetenceCard', {
                firstName: firstName,
				surName: surName,
				personalIdentityNumber: personalIdentityNumber,
				employeeNumber: employeeNumber,
				employmentDate: employmentDate,
				email: email,
				role: role,
				drivingLicense: drivingLicense,
				workplaceId: workplaceId,
				experience: experience,
				education: education,
            }).then(id => {
				this.dataId = id;
                this.$router.push({
                    name: 'competence-card',
                    params: {
                        id: id
                    }
                });
				this.mode = 'view';
			});
		},
		edit({ id, firstName, surName, personalIdentityNumber, employeeNumber, employmentDate, email, role, drivingLicense, experience, education }) {
            this.$store.dispatch('competences/editCompetenceCard', {
                id: id,
                firstName: firstName,
				surName: surName,
				personalIdentityNumber: personalIdentityNumber,
				employeeNumber: employeeNumber,
				employmentDate: employmentDate,
				email: email,
				role: role,
				drivingLicense: drivingLicense,
				experience: experience,
				education: education
            });
		},
		generatePdf() {
			this.$store.dispatch('competences/generatePdf', this.dataId);
		}
	},
    render() {
        if (!this.$scopedSlots.default) {
            return;
        }

        const slotScope = {
			loading: this.loading,
			competenceCard: this.competenceCard(this.dataId),
			competenceRows: this.competenceRows(this.dataId),
			courseRows: this.courseRows(this.dataId),
			workplaceOptions: this.workplaceOptions,
			mode: this.mode,
			create: this.create,
			edit: this.edit,
			delete: this.delete,
			generatePdf: this.generatePdf,
		};

        return this.$scopedSlots.default(slotScope);
    },
    created() {
		if (this.competenceCardId !== '0') {
            this.mode = 'view';
            this.dataId = this.competenceCardId;
        } else {
            this.mode = 'create';
		}
        if (this.dataId !== '0') {
			this.$store.dispatch('competences/fetchCompetenceCard', {id: this.dataId })
			.then(() => {
                this.success = true;
			});
		}
    }
}
</script>
